const user = "rronaliu";

export const links = [
	{
		label: "Github",
		url: `https://github.com/${user}`,
	},
	{
		label: "Linkedin",
		url: `https://www.linkedin.com/in/rron-aliu-6b79b8bb/`,
	}
];

export const email = "rronaliu95@gmail.com";